import { Component } from '@theme/component';

/**
 * Contact form wrapper that publishes a consent-managed Shopify Custom Pixel
 * event ('medicross:partner_lead') once the contact form has posted
 * successfully. The official Meta pixel (Facebook & Instagram channel + CAPI)
 * handles ad attribution downstream — this only signals the lead, no PII.
 *
 * @extends {Component}
 */
class PartnerContactForm extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.querySelector('.partner-contact-form__success')) {
      // @ts-ignore - Shopify.analytics is injected at runtime, not in the bundled typings.
      window.Shopify?.analytics?.publish('medicross:partner_lead', {
        source: this.dataset.leadSource || 'Geschäftspartner',
      });
    }
  }
}

if (!customElements.get('partner-contact-form')) {
  customElements.define('partner-contact-form', PartnerContactForm);
}
